<template>
  <g :transform="gTransform">
    <!-- legend -->
    <rect x="30" y="0" width="100" height="10" fill="#e6f1fd" />
    <rect x="60" y="14" width="40" height="10" fill="#c5e1ff" />

    <rect x="0" y="7" width="30" height="10" fill="#FFB3B3" />
    <rect x="30" y="7" width="30" height="10" fill="gold" />
    <rect x="60" y="7" width="40" height="10" fill="#BCFFB3" />
    <rect x="100" y="7" width="30" height="10" fill="#B3FFFF" />
    <rect x="130" y="7" width="30" height="10" fill="#D9B3FF" />
    
    <text style="font: bold 6px sans-serif;" x="68" y="-3" >Legend</text>
    <text style="font: 5.5px sans-serif;" fill="#404040" x="3" y="14" >Extreme</text>
    <text style="font: 5.5px sans-serif;" fill="#404040" x="33" y="14">Deficient</text>
    <text style="font: 5.5px sans-serif;" fill="#404040" x="68" y="14">Sufficient</text>
    <text style="font: 5.5px sans-serif;" fill="#404040" x="103" y="14">Luxury</text>
    <text style="font: 5.5px sans-serif;" fill="#404040" x="133" y="14">Excessive</text>

  </g>
</template>

<script>
export default {
  name: "svg-legend",
  props: {
    x: {
      type: Number,
      default: 0
    },
    y: {
      type: Number,
      default: 0
    }
  },
  computed: {
    gTransform() {
      return `translate(${this.x},${this.y})`;
    }
  }
};
</script>

<style lang="scss" scoped>

</style>